"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var Div_1 = __importDefault(require("../Div"));
var itemInformation_1 = require("../PriceItems/itemInformation");
var PlussaCard_1 = __importDefault(require("./PlussaCard"));
var ProductBatchSize_1 = __importDefault(require("./ProductBatchSize"));
var LeftContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 80%;\n  float: left;\n"], ["\n  width: 80%;\n  float: left;\n"])));
var RightContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 20%;\n  float: right;\n"], ["\n  width: 20%;\n  float: right;\n"
    // without position: relative Tizen player does not show number correctly
])));
// without position: relative Tizen player does not show number correctly
var Integers = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  font-size: ", "px;\n  float: left;\n  line-height: 0.9;\n"], ["\n  position: relative;\n  font-size: ", "px;\n  float: left;\n  line-height: 0.9;\n"])), function (props) { return (props.fontSize ? props.fontSize : '350'); });
var DecimalsContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  float: left;\n  top: 18px;\n  position: relative;\n"], ["\n  float: left;\n  top: 18px;\n  position: relative;\n"])));
var Decimals = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: 0.9;\n  margin-bottom: 10px;\n"], ["\n  font-size: ", "px;\n  line-height: 0.9;\n  margin-bottom: 10px;\n"])), function (props) { return (props.fontSize ? props.fontSize : '175'); });
var UnitText = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-family: 'Skatta Sans Regular';\n  font-size: ", "px;\n  padding-left: 4px;\n  line-height: 1.1;\n"], ["\n  font-family: 'Skatta Sans Regular';\n  font-size: ", "px;\n  padding-left: 4px;\n  line-height: 1.1;\n"])), function (props) { return (props.fontSize ? props.fontSize : '35'); });
var DiscountText = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-family: 'Skatta Sans Regular';\n  font-size: ", "px;\n  padding-left: 4px;\n  line-height: 1.1;\n"], ["\n  font-family: 'Skatta Sans Regular';\n  font-size: ", "px;\n  padding-left: 4px;\n  line-height: 1.1;\n"])), function (props) { return (props.fontSize ? props.fontSize : '35'); });
var generatePriceStyles = function (styles) {
    return __assign({ fontFamily: 'Skatta Sans Bold' }, styles);
};
var getIntegerProps = function (integers) { return ({
    fontSize: parseFloat(integers) > 100 ? 300 : 350
}); };
var getDecimalsProps = function (integers) { return ({
    fontSize: parseFloat(integers) > 100 ? 125 : 175
}); };
var getUnitTextProps = function (integers) { return ({
    fontSize: parseFloat(integers) > 100 ? 30 : 40
}); };
var ProductOfferPrice = function (_a) {
    var styles = _a.styles, item = _a.item;
    var price = item.price, discountPrice = item.discountPrice;
    var currentPrice = discountPrice || price;
    if (!currentPrice) {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    var _b = (0, itemInformation_1.generateRetailProductPriceInformation)(currentPrice, item), integers = _b.integers, decimals = _b.decimals, unitText = _b.unitText, discountText = _b.discountText;
    return (react_1.default.createElement(Div_1.default, { styles: generatePriceStyles(styles) },
        react_1.default.createElement(LeftContainer, null, integers && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Integers, __assign({ id: 'price-integers' }, getIntegerProps(integers)), integers),
            react_1.default.createElement(DecimalsContainer, { id: 'price-decimals-container' },
                react_1.default.createElement(Decimals, __assign({ id: 'price-decimals' }, getDecimalsProps(integers)), decimals),
                react_1.default.createElement(UnitText, __assign({ id: 'price-unit-text' }, getUnitTextProps(integers)), unitText),
                react_1.default.createElement(DiscountText, __assign({ id: 'price-discount-text' }, getUnitTextProps(integers)), discountText))))),
        react_1.default.createElement(RightContainer, null,
            react_1.default.createElement(ProductBatchSize_1.default, { item: item }),
            react_1.default.createElement(PlussaCard_1.default, { item: item }))));
};
exports.default = ProductOfferPrice;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=ProductOfferPrice.js.map